export default "__VITE_ASSET__Dn9_g62d__"